import { InputProps } from 'antd';
import { Rule } from 'antd/es/form';
import React, { RefObject } from 'react';
import { MaskedInput, MaskedInputRef } from './MaskedInput';
import { useCustomFormItemErrorsAndWarnings } from '../../logik/hooks/form.hooks';

export const MONEY_INPUT_MASK = '$ money';
export const isMoney = (value: string): boolean => {
    const reg = new RegExp(`^${MONEY_INPUT_MASK.replace('money', '-?\\d+([.,]\\d+)?').replace('$', '\\$')}$`);
    return value ? reg.test(value.toString()) : false;
};

export const moneyToNumber = (value: string): number => {
    return Number(value.toString().replace(MONEY_INPUT_MASK.replace('money', ''), ''));
};

export type MoneyInputRef = MaskedInputRef & {
    validators: Rule[];
};
export type MoneyInputInputProps = InputProps & React.RefAttributes<MoneyInputRef>;
export const getMoneyInputValidators = (ref: RefObject<MoneyInputRef>, message?: string): Rule[] => [
    {
        validator: () => {
            const valid = (ref.current?.getUnMaskedValue()?.trim().length ?? 0) > 0;

            return valid ? Promise.resolve() : Promise.reject();
        },
        message: message ?? '${name} is required',
    },
];

export const MoneyInput = React.forwardRef<Partial<MoneyInputRef>, MoneyInputInputProps>(function MoneyInput(
    // eslint-disable-next-line react/prop-types
    { onBlur, ...props }: MoneyInputInputProps,
    innerRef,
): JSX.Element {
    useCustomFormItemErrorsAndWarnings();

    return (
        <MaskedInput
            maskOptions={{
                mask: MONEY_INPUT_MASK,
                lazy: false,
                blocks: {
                    money: {
                        mask: Number,
                        signed: true,
                        thousandsSeparator: '',
                        radix: '.',
                        mapToRadix: [','],
                        scale: 2,
                        normalizeZeros: false,
                        padFractionalZeros: false,
                    },
                },
            }}
            onBlur={(e) => {
                const value = e.target.value;
                if (value.endsWith('.') || value.endsWith(',')) {
                    e.target.value += '00';
                }
                onBlur?.(e);
            }}
            {...props}
            ref={innerRef}
        />
    );
});
